

if (!customElements.get('faq-component') && !customElements.get('faq-selector')) {
  class FaqComponent extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('.faq-item__heading').forEach(element => {
        element.addEventListener('click', (event) => {
            event.currentTarget.parentElement.classList.toggle("open");
        });
      });
    }
  }

  customElements.define('faq-component', FaqComponent);

  class FaqSelector extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll(".faq-selector__item");
      this.faqs = document.querySelectorAll(".faq[data-anchor]");

      this.select(this.buttons[0]);

      this.buttons.forEach(button => {
        button.addEventListener("click", this.select.bind(this, button));
      });
    }

    select(button) {
      const anchor = button.dataset.anchor;
      if (anchor) {
        const faq = document.querySelector(`.faq[data-anchor="${anchor}"]`);
        if (faq) {
          for (const b of this.buttons) {
            b.classList.remove('active');
          }
          for (const f of this.faqs) {
            f.classList.remove('active');
          }
          faq.classList.add('active');
          button.classList.add('active');
        }
      }
    }
  }

  customElements.define('faq-selector', FaqSelector);
}